import { isNullOrUndefined } from '@fiji/common/src/utils/helpers';

const updateChannelData = (stateClone: any, category: string, index: number, actionPayload: any): void => {
    stateClone.data[category][index]['value'] = actionPayload.value;
    stateClone.data[category][index]['enumDisplayName'] = actionPayload.enumDisplayName;
    stateClone.data[category][index]['enumName'] = actionPayload.enumName;
};

const reducer = (state: any, action: any): any => {
    const stateClone = JSON.parse(JSON.stringify(state ?? {}));
    const category = action.payload?.category;
    const selectedChannelIndex = category
        ? stateClone?.data?.[category]?.findIndex?.((item: any) => item?.channelId === action.payload?.key)
        : undefined;
    switch (action.type) {
        case 'SET_DATA':
            return { ...action.payload };
        case 'UPDATE_DATA':
            if (selectedChannelIndex !== -1 && !isNullOrUndefined(selectedChannelIndex)) {
                updateChannelData(stateClone, category, selectedChannelIndex, action.payload);
            }
            return stateClone;
        default:
            return state;
    }
};

export { reducer };
